import { useEffect } from "react";

/**
 * Adds a <meta name="robots" content="noindex, nofollow"> tag to <head>
 * while mounted, and removes it on unmount. Use on auth, dashboard, and
 * admin pages that should never be indexed by search engines.
 */
export default function NoIndexMeta() {
  useEffect(() => {
    let el = document.head.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
    return () => {
      if (el && el.getAttribute("content") === "noindex, nofollow") {
        el.remove();
      }
    };
  }, []);
  return null;
}